import { Column } from "react-table";

export const COLUMNS: Column[] | any = [
  {
    id: "feedbacks",
    Header: "Feedback",
    accessor: "feedback",
  },
];
